import { create } from "zustand";

import { AuthenticationStatus } from "./types/authentication-status";

interface AuthState {
  authStatus: AuthenticationStatus;
  username: string | null;
  persistentLogin: boolean;
  currentMfaType: number | null;
  pageCompanyId: number | null;
  error: string;
  mfaMaskedEmail: string | null;
  isChangingGroup: boolean;
  totpSecret: string | null;
  totpQrUri: string | null;
  requiresMfaStepUp: boolean;
  setPageCompanyId: (id: number | null) => void;
  setAuthStatus: (authStatus: AuthenticationStatus) => void;
  setError: (error: string) => void;
  setUsername: (username: string | null) => void;
  setPersistentLogin: (persistentLogin: boolean) => void;
  setCurrentMfaType: (mfaType: number | null) => void;
  setTotpSecret: (totpSecret: string | null) => void;
  setTotpQrUri: (totpQrUri: string | null) => void;
  setRequiresMfaStepUp: (
    requiresMfaStepUp: boolean,
    mfaType: number | null,
    mfaMaskedEmail: string | null
  ) => void;
  setMfaMaskedEmail: (mfaMaskedEmail: string | null) => void;
  setIsChangingGroup: (isChangingGroup: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  // persist(
  (set) => {
    return {
      authStatus: AuthenticationStatus.Loading,
      error: "",
      username: null,
      pageCompanyId: null,
      persistentLogin: false,
      currentMfaType: null,
      totpSecret: null,
      totpQrUri: null,
      requiresMfaStepUp: false,
      mfaMaskedEmail: null,
      isChangingGroup: false,
      setMfaMaskedEmail: (mfaMaskedEmail: string | null) =>
        set(() => ({ mfaMaskedEmail: mfaMaskedEmail })),
      setRequiresMfaStepUp: (
        requiresMfaStepUp: boolean,
        mfaType: number | null,
        mfaMaskedEmail: string | null
      ) => {
        set(() => ({
          requiresMfaStepUp,
          currentMfaType: mfaType,
          mfaMaskedEmail: mfaMaskedEmail,
        }));
      },
      setTotpSecret: (totpSecret: string | null) =>
        set(() => ({ totpSecret: totpSecret })),
      setTotpQrUri: (totpQrUri: string | null) =>
        set(() => ({ totpQrUri: totpQrUri })),
      setCurrentMfaType: (mfaType: number | null) =>
        set(() => ({ currentMfaType: mfaType })),
      setPageCompanyId: (id: number | null) => {
        set(() => ({ pageCompanyId: id }));
      },
      setAuthStatus: (authStatus: AuthenticationStatus) =>
        set(() => ({ authStatus })),
      setError: (error: string) => set(() => ({ error })),
      setUsername: (username: string | null) => set(() => ({ username })),
      setPersistentLogin: (persistentLogin: boolean) =>
        set(() => ({ persistentLogin })),
      setIsChangingGroup: (isChangingGroup: boolean) =>
        set(() => ({ isChangingGroup })),
    };
  }
);
